export const IxCardEvents = {
  ToggleCard: 'toggle-card',
  ShowTooltip: 'show-tooltip',
  HideTooltip: 'hide-tooltip',
};
